import { OrderStatus } from '@cpce/database/enums';
import z from 'zod';
import { purchaseLineShape, refinePurchaseLine } from './purchase-lines.types.js';
export const orderWithRelations = {
    include: {
        supplier: { select: { id: true, name: true } },
        invoices: {
            select: {
                id: true,
                reference: true,
                dueDate: true,
                documentReceivedAt: true,
                accrualTransaction: { select: { date: true } },
            },
        },
        lines: {
            orderBy: { position: 'asc' },
            include: {
                prestation: { select: { id: true, name: true } },
                prestationPrice: { select: { id: true, name: true, price: true } },
                accountingCategories: { select: { id: true, name: true, parentId: true } },
            },
        },
    },
};
export const orderLineDataSchema = z
    .object({
    ...purchaseLineShape,
    isValidated: z.boolean().default(false),
    // Not stored on the order: the charge account of the matching line of the generated invoice.
    // Omitted keeps the account that line already has, else the supplier's default, else 471.
    chargeAccountCode: z.string().min(1).optional(),
})
    .superRefine(refinePurchaseLine);
export const orderDataSchema = z.object({
    supplierId: z.number().int().positive({ message: 'Le fournisseur est requis' }),
    reference: z.string({ message: 'La référence est requise' }).min(1, 'La référence est requise'),
    date: z.coerce.date({ message: 'La date est requise' }),
    remarks: z.string().optional().nullable(),
    status: z.enum(OrderStatus).default(OrderStatus.pending),
    lines: z.array(orderLineDataSchema).min(1, 'Au moins une ligne est requise'),
});
// `status` is redeclared without its default: a default still fires on a partial schema, and would
// send a validated order back to « En attente » on every edit that doesn't mention it.
export const partialOrderDataSchema = orderDataSchema
    .extend({ status: z.enum(OrderStatus) })
    .partial();
